import { AutoInfracaoAPI } from "@/api/auto_infracao.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { AutoInfracao } from "@/models/auto_infracao";

const autoInfracaoAPI = new AutoInfracaoAPI();

const loadAutosInfracaoNotificar = (
  cnpj: string,
  token: string,
  numOrdem: number
): AxiosObservable<AutoInfracao[]> => {
  return autoInfracaoAPI.loadAutosInfracaoNotificar(cnpj, token, numOrdem);
};

const loadAutosInfracaoNotificarAtualizar = (
  cnpj: string,
  token: string,
  numOrdem: number
): AxiosObservable<AutoInfracao[]> => {
  return autoInfracaoAPI.loadAutosInfracaoNotificarAtualizar(
    cnpj,
    token,
    numOrdem
  );
};

const loadAutoInfracaoAptosDividaAtiva = (
  cnpj: string,
  token: string,
  numOrdem:  number
): AxiosObservable<AutoInfracao[]> => {
  return autoInfracaoAPI.autoInfracaoAptosDividaAtiva(cnpj, token, numOrdem);
};

const loadAutoInfracaoAptosDividaAtivaPorPlaca = (
  cnpj: string,
  token: string,
  numOrdem: number,
  placa: string
): AxiosObservable<AutoInfracao[]> => {
  return autoInfracaoAPI.autoInfracaoAptosDividaAtivaPorPlaca(
    cnpj,
    token,
    numOrdem,
    placa
  );
};

const imprimirAutosInfracao = (autos: Array<string>): AxiosObservable<any> => {
  return autoInfracaoAPI.imprimirAutosInfracao(autos);
};

const gerarAutoInfracaoDae = (
  cnpj: string,
  taxasAutos: Array<string>,
  transportadoraId: number,
  placa: string,
  recaptcha: string,
  numOrdem: string
): AxiosObservable<any> => {
  return autoInfracaoAPI.gerarAutoInfracaoDae(
    cnpj,
    taxasAutos,
    transportadoraId,
    placa,
    recaptcha,
    numOrdem
  );
};

const findBy = (
  cnpj: string,
  placa: string,
  renavam: string
): AxiosObservable<AutoInfracao[]> => {
  return autoInfracaoAPI.findBy(cnpj, placa, renavam);
};

export default {
  loadAutosInfracaoNotificar,
  loadAutosInfracaoNotificarAtualizar,
  loadAutoInfracaoAptosDividaAtiva,
  loadAutoInfracaoAptosDividaAtivaPorPlaca,
  imprimirAutosInfracao,
  gerarAutoInfracaoDae,
  findBy
};
